import SearchComp from "components/Searchcomponent";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { DatePicker } from 'rsuite';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { LabelField } from "components";
import InfoTooltip from "components/InfoTooltip";
import { getDateFormat, getDateFormatForDatePicket } from "helper";

const styles = { width: 200, display: 'block', marginBottom: 10 };

export function PeddingFillter({
  filter,
  onSearchChange,
  onPaidDateChange,
  pendingType,
  date,
  setDate,
  localFormat,
}) {

  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();


  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {},
    validationSchema: "",
    onSubmit: async (values) => { },
  });
  useEffect(() => {
      setDate(null)
  }, [pendingType])
  return (
    <div className=" col-mb-12 col-xs-12 col-lg-10 col-sm-10 d-flex activated-ledger d-flex flex-column flex-lg-row justify-content-between  pr-0 pl-0">
      <div className="sub-header-functions pl-0 pt-5 pb-3 col-mb-12 col-xs-12 col-lg-12 col-sm-12 ">
        <SearchComp
          value={filter?.search}
          setSearchText={onSearchChange}
          placeholder="Search "
          height="50px"
        />
      </div>
      <div className="col-mb-12 col-xs-12 col-lg-8 col-sm-9 deposit-synced-batch-date">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LabelField
            title={`${pendingType === "Pending" ? "Batch Date" : "Deposit Date"
              } `}
            mandatory
          />
          <InfoTooltip text="Filter batches by the date they were created (Batch Date) or the date they were deposited (Deposit Date)." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </div>
        {console.log(date, "datedatedate")}

        <div
          className="batch_date"
        >
          <DatePicker size="lg" 
          format={dateFormate}
          placeholder={placeholderFormat}
            value={date && new Date(date)}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }} style={styles} onChange={onPaidDateChange}
          />
          {date !== null && <div style={{
            position: "absolute",
            top: "43px",
            right: "60px",
            color: "#8080da",
            cursor: 'pointer',
            zIndex: "99999999",
          }} onClick={() => { onPaidDateChange(null) }
          }>clear</div>}
        </div>
      </div>
    </div>
  );
}
